import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useImportMathToolsDrawing } from 'customHooks/canvas';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import Icon from 'components/Icon';
import styles from './index.module.scss';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useStore, StoreTypes } from 'context';
import { useFetchBooks } from 'customHooks/book';
import { useWindowSize } from 'customHooks/windowSize';
import { domToBlob } from 'modern-screenshot';
import { ReaderZoomType } from 'constants/ReaderTools';

const MathToolsContainer = ({ mathToolsInfo }) => {
  //const ifraRef = useRef() //use this iframe can not get contentWindow
  const { type } = mathToolsInfo
  const [ifraRef, setContentRef] = useState(null)
  const importMathToolsDrawing = useImportMathToolsDrawing();
  const waitJsonResolveRef = useRef(null)
  const [{ isDoublePageMode, pageIndex }] = useStore(StoreTypes.reader);
  const [{ books, bookId, bookContent, style }] = useStore(StoreTypes.books);
  const windowSize = useWindowSize();
  const { fetchBook } = useFetchBooks();
  const closeLeftHandler = () => {
    closeRightHandler();
  }
  const closeRightHandler = async () => {
    const importAndClose = async () => {
      try {
        if (!ifraRef || !ifraRef.contentWindow) throw new Error('iframe not ready');
        let mappingInfo = null;
        try {
          const toolDoc = ifraRef.contentWindow.document;
          const toolContainer = toolDoc && toolDoc.getElementById('animation_container');
          const toolCanvas = toolDoc && toolDoc.getElementById('canvas');
          const readerCanvas = document.querySelector('canvas.lower-canvas');
          const iframeRect = ifraRef.getBoundingClientRect();
          const targetToolEl = toolContainer || toolCanvas;
          if (targetToolEl && readerCanvas) {
            mappingInfo = {
              toolRect: targetToolEl.getBoundingClientRect(),
              readerRect: readerCanvas.getBoundingClientRect(),
              iframeRect,
              baseW: 1400,
              baseH: 1050
            };
          }
        } catch (e) {}
        let jsonStr = null;
        try {
          if (typeof ifraRef.contentWindow.exportDrawingJSON === 'function') {
            jsonStr = ifraRef.contentWindow.exportDrawingJSON();
          }
        } catch (e) {}
        if (!jsonStr) {
          jsonStr = await new Promise((resolve) => {
            waitJsonResolveRef.current = resolve;
            ifraRef.contentWindow.postMessage({ msg: 'ExportMathToolsJSON' }, '*');
            setTimeout(() => resolve(null), 100);
          });
        }
        if (jsonStr) await importMathToolsDrawing({ json: jsonStr, mappingInfo });
      } catch (e) {
      } finally {
        EventBus.emit({ event: ReaderToolsEvent.ClickMathToolsEvent, payload: { mathToolsInfo: null } });
      }
    };

    confirmAlert({
      title: '是否儲存畫記到電子書',
      message: null,
      buttons: [
        {
          label: '是',
          onClick: () => importAndClose()
        },
        {
          label: '否',
          onClick: () => EventBus.emit({ event: ReaderToolsEvent.ClickMathToolsEvent, payload: { mathToolsInfo: null } })
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true
    });
  }

  useEffect(() => {
    const handler = (event) => {
      const { data } = event;
      if (!data || data.type !== 'MathToolsJSON') return;
      if (waitJsonResolveRef.current) {
        waitJsonResolveRef.current(data.payload || null);
        waitJsonResolveRef.current = null;
      }
    }
    window.addEventListener('message', handler, false);
    return () => window.removeEventListener('message', handler);
  }, [])

  const iframeOnLoad = useCallback(() => {
    if (!ifraRef) return;
    setTimeout(() => {
      const run = async () => {
        try {
          const waitForResizeBook = async () => {
            EventBus.emit({
              event: ReaderToolsEvent.SetReaderZoomEvent,
              payload: { type: ReaderZoomType.OriginZoom },
            });
            await new Promise(resolve => setTimeout(resolve, 100));
          };

          // 先確保當前頁面內容已載入
          if (bookId) {
            let pages = isDoublePageMode ? [pageIndex * 2, pageIndex * 2 + 1] : [pageIndex];
            pages = pages.filter(p => !bookContent || !bookContent[p]);
            if (pages.length > 0) {
              fetchBook({ bookId, pages });
            }
          }

          // 取得書本資訊
          const bookInfo = (books || []).find(b => b.bookId === bookId);

          // 產生目前畫面（已為雙頁區域）的 base64 PNG 並傳給工具
          if (ifraRef.contentWindow && bookInfo) {
            await waitForResizeBook();
            const targetEl = document.querySelector('#studentScreenshotArea');
            const readerCanvas = document.querySelector('canvas.lower-canvas');
            const readerView = document.getElementById('readerView');
            if (targetEl) {
              try {
                // const blob = await domToBlob(targetEl, {
                //   type: 'image/png',
                //   width: targetEl.offsetWidth,
                //   height: targetEl.offsetHeight,
                //   backgroundColor: 'white',
                //   scale: 2,
                //   fetchRequestInit: {
                //     cache: 'no-cache',
                //   }
                // });
                // const dataUrl = await new Promise((resolve, reject) => {
                //   const reader = new FileReader();
                //   reader.onload = () => resolve(reader.result);
                //   reader.onerror = reject;
                //   reader.readAsDataURL(blob);
                // });
                // // 工具端仍以 images 結構讀取，這裡僅傳單一頁（雙頁合併畫面）
                // const images = [{ pageIndex: 0, svg: dataUrl }];
                // // 計算可視內容在截圖中的內框（排除左右翻頁箭頭的空白）
                // let contentBounds = null;
                // const shotRect = targetEl.getBoundingClientRect();
                // // 直接依視窗寬與書本內容寬推得 LRGap（左右白邊）
                const LRGapValue = (windowSize && windowSize.width != null && style && style.width != null)
                //   ? Math.max(0, Math.round((windowSize.width - style.width) * 0.5))
                //   : 0;
                // // contentBounds 可選: 若需要同時告訴工具可視內容矩形，可用 readerView 為基準
                // if (readerView) {
                //   const rvRect = readerView.getBoundingClientRect();
                //   contentBounds = {
                //     x: Math.max(0, Math.round(rvRect.left - shotRect.left + LRGapValue)),
                //     y: Math.max(0, Math.round(rvRect.top - shotRect.top)),
                //     width: Math.max(0, Math.round(rvRect.width - LRGapValue * 2)),
                //     height: Math.max(0, Math.round(rvRect.height)),
                //   };
                // }
                // console.log('LRGapValue',LRGapValue);
                
                ifraRef.contentWindow.postMessage({ type: 'ReaderPageData', payload: { images:null, width: targetEl.offsetWidth, height: targetEl.offsetHeight, contentBounds:null, lrGap: LRGapValue ,fullWidthMode:true} }, '*');
              } catch (e) {}
            }
          }
        } catch (e) {
        } finally {
          // 圖片送達後再初始化工具
          createMathTools(type, ifraRef.contentWindow.flashRoot)
        }
      };
      run();
    }, 300);
  }, [type, ifraRef, books, bookId, isDoublePageMode, pageIndex, fetchBook, bookContent])

  const createMathTools = (type, flashRoot) => {
    flashRoot.mathToolsInit(type);
  }

  return (
    <div className={styles.mathToolsContainer}>
      <iframe ref={setContentRef} className={styles.iframe} onLoad={() => iframeOnLoad()} title="compass" src="assets/MathTools/MathTools.html" frameborder="0"></iframe>
      <div className={styles.closeLeftButton} onClick={closeLeftHandler}><Icon name="Close" /></div>
      <div className={styles.closeRightButton} onClick={closeRightHandler}><Icon name="Close" /></div>
    </div>
  )
}

export default MathToolsContainer;
